import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  Lists_donvitinh, Lists_phongban, Lists_loaitaisan
  , Lists_loaikhoan, Lists_tieumuc, Lists_nguonhinhthanh
  , Lists_nganhang
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';


const swal = require('sweetalert');
@Component({
    selector: 'app-quantri-donviedit',
  templateUrl: './donviedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./donviedit.component.scss'],
    providers: [ListService, Repository]
})


export class donvieditComponent implements OnInit {

    @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
    @ViewChild('dteChung', { static: false }) doituongchungedit: any;
    @ViewChild('slTaiKhoanNH', { static: false }) slTaiKhoanNH: any;
    @ViewChild('inputTenKB', { static: false }) inputTenKB: any;
  
    inputkhoidonvis: any;

    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

    inputparents: any;
    inputnganhangs: any;
  

  
    donviid: any;
    tabselected: number = 1;

    indLoading: boolean = false;    
    doituongSelect: any = {
    Id: null, Ma_Don_Vi: null, Ten_Don_Vi: null, Dia_Chi: null, Ma_So_Thue: null, Dien_Thoai: null, Fax: null, Hom_Thue:null,Ma_Ao:null,
    Parent: null, Mo_Ta: null, MaDBHC: null, SoTaiKhoanNH: null, Quan_Huyen: null
    , Tinh_TP: null, DonViChuQuan: null, KBNN_TaiKhoan_Id: null, KBNN_Ten: null
    , KBNN_DiaChi: null, Ky_ThuTruongDonVi: null, Ky_KeToanTruong: null, Ky_KeToanVien: null
    , Ky_ThuQuy: null, Ky_ThuKho: null, Ky_NguoiLapBaoCao: null, Thu_Tu:null, KhoiId: null, MauDuToan: null
    };    
    nhomdtid:string=null;


    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
      

    }
  comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
  }
  onDoiTuongChange($event) {

    if (typeof $event === "undefined") {
      this.doituongSelect.KBNN_Ten = null;
    }
    else
      this.doituongSelect.KBNN_Ten = $event.Ten_Doi_Tuong;
  }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        let data = JSON.parse(authlogin);
        this.donviid = data.id_don_vi;
        var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        this.repo.getRequest("api/doituong/getall2/" + Lists_nganhang.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputnganhangs = response;
        });
      this.repo.getRequest("api/donvi/getall/")
        .subscribe(response => {
          this.inputparents = response;
        });

        this.repo.getRequest("api/donvi/getkhoidonvi/")
        .subscribe(response => {
          this.inputkhoidonvis = response;
        });
     

      this.doituongSelect = {
        Id: null, Ma_Don_Vi: null, Ten_Don_Vi: null, Dia_Chi: null, Ma_So_Thue: null, Dien_Thoai: null, Fax: null, Hom_Thue: null, Ma_Ao: null,
        Parent: null, Mo_Ta: null, MaDBHC: null, SoTaiKhoanNH: null, Quan_Huyen: null
        , Tinh_TP: null, DonViChuQuan: null, KBNN_TaiKhoan_Id: null, KBNN_Ten: null
        , KBNN_DiaChi: null, Ky_ThuTruongDonVi: null, Ky_KeToanTruong: null, Ky_KeToanVien: null
        , Ky_ThuQuy: null, Ky_ThuKho: null, Ky_NguoiLapBaoCao: null, Thu_Tu: null, KhoiId: null, MauDuToan: null
      };    
        
        if(id === null)
        {
          
        }
        else {
            console.log(id);
          this.repo.getRequest("api/donvi/getbyid/" + id)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Id = id;
                this.doituongSelect.Ma_Don_Vi = response.Ma_Don_Vi;
                this.doituongSelect.Ten_Don_Vi = response.Ten_Don_Vi;
                this.doituongSelect.Dia_Chi = response.Dia_Chi;
                this.doituongSelect.Ma_So_Thue = response.Ma_So_Thue;
                this.doituongSelect.Dien_Thoai = response.Dien_Thoai;
                this.doituongSelect.Fax = response.Fax;
                this.doituongSelect.Hom_Thue = response.Hom_Thue;
                this.doituongSelect.Ma_Ao = response.Ma_Ao;
                this.doituongSelect.Parent = response.Parent;
                this.doituongSelect.Mo_Ta = response.Mo_Ta;
                this.doituongSelect.MaDBHC = response.MaDBHC;
                this.doituongSelect.SoTaiKhoanNH = response.SoTaiKhoanNH;
                this.doituongSelect.Quan_Huyen = response.Quan_Huyen;
                this.doituongSelect.Tinh_TP = response.Tinh_TP;
                this.doituongSelect.DonViChuQuan = response.DonViChuQuan;
                this.doituongSelect.KBNN_TaiKhoan_Id = response.KBNN_TaiKhoan_Id;
                this.doituongSelect.KBNN_Ten = response.KBNN_Ten;
                this.doituongSelect.KBNN_DiaChi = response.KBNN_DiaChi;
                this.doituongSelect.Ky_ThuTruongDonVi = response.Ky_ThuTruongDonVi;
                this.doituongSelect.Ky_KeToanTruong = response.Ky_KeToanTruong;
                this.doituongSelect.Ky_KeToanVien = response.Ky_KeToanVien;
                this.doituongSelect.Ky_ThuQuy = response.Ky_ThuQuy;
                this.doituongSelect.Ky_ThuKho = response.Ky_ThuKho;
                this.doituongSelect.Ky_NguoiLapBaoCao = response.Ky_NguoiLapBaoCao;
              this.doituongSelect.Thu_Tu = response.Thu_Tu;
              this.doituongSelect.KhoiId = response.KhoiId;
              this.doituongSelect.MauDuToan = response.MauDuToan;
              
            }); 
        }
        
       
    }
  selectedTab(tab: number) {
    this.tabselected = tab;
    if (tab === 2) {

    }
    else {
      setTimeout(() => {
        this.mafocus.nativeElement.focus();
      }, 100);
    }
   
  }
    keyTenPress(event: any) { 
        if (event.which === 13) {
          // this.slLoaiTaiSan.focus();
            event.preventDefault();
          }
  }
  keySoTKPress(event: any) {
    if (event.which === 13) {
       this.inputTenKB.focus();
      event.preventDefault();
    }
  }
  

  
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    if (this.doituongSelect.Ma_Don_Vi == null || this.doituongSelect.Ma_Don_Vi == "") {
      swal('Lỗi!', 'Vui lòng nhập mã QHNS!.', 'error');
      return;
    }
      if (this.doituongSelect.Ten_Don_Vi == null || this.doituongSelect.Ten_Don_Vi == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đơn vị!.', 'error');
            return;
      }

      
      
      this.repo.postRequest("api/donvi/addorupdate",this.doituongSelect)
        .subscribe(response => {
                    if (response != null && response.match('-')) {
                      this.doituongSelect.Id = response;
                      this.save.emit(this.doituongSelect);
                    }
                    else {
                      swal('Lỗi!', response, 'error');
                    }
               
            }); 
    }
   
  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent) {

    this.comboSeleted = cobo;
    cobo.close();
    this.doituongchungedit.loadDataInit(Lists_nganhang.id, null, this.donviid);
    this.mdDoiTuongChung.open();
  }
  saveModal(doituong: any) {
    console.log(doituong);
    this.mdDoiTuongChung.dismiss();
    this.comboSeleted.focus();
  }
   


}


